import { action, payload } from 'ts-action'
import { ITemplate } from 'models/Template'
import { IError, IPayload } from 'models/Global'

export const TemplateFetching = action('TemplateFetching', payload<boolean>())

export const GetTemplate = action('GetTemplate', payload<IPayload<ITemplate>>())

export const GetTemplateErrors = action('GetTemplateErrors', payload<IError>())
